<router-outlet></router-outlet>
<div class="exit">
  <button [class.clicked]="isClicked" class="exit-button" tabindex="0" (click)="navigateToGoogle()"
    (keydown.enter)="navigateToGoogle()" class="exit-button">
    <img aria-label="Exit this page" src="../assets/images/exit-icon.svg" alt="Exit">
  </button>
  <span class="exit-text">Exit <br> this page</span>
</div>